export default __webpack_public_path__ + "static/media/map.0acaa4df.png";